import { companySignatureTable } from "../../../logged-in/shared/functions/scorecard-pdf/DocDefition";
import { fullPerspectiveName } from "../../interfaces/IPerspectiveTabs";
import { IMeasure } from "../../models/Measure";
import { IObjective } from "../../models/Objective";
import { dataFormat } from "../Directives";
import { marginTopBottom, header, sectionHeader } from "./DocDefition";
import { brandLogo, footerStripes } from "./ImageDefinition";

type RowSpan = {
  text: string | any;
  rowSpan?: number;
  style?: string;
};

const tableWidths: Row = [
  100,
  "*",
  "*",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  //
  "auto",
  "auto",
  "auto",
  //
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
  "auto",
];

const tableHeader: Row = [
  "Perspective",
  "Contributory Objective",
  "Individual  Scorecard Contribution",
  "Weight (%)",
  //
  "Draft Comment",
  "Midterm Comment",
  "Assessment Comment",
  //
  "Measures/KPI",
  "Baseline",
  "Annual Target",
  "Rating Scale 1-5",
  "Key Initiatives",
  "Target Date",
  "Source of Evidence",
  "KPI Comments",
  "Midterm E Rating",
  "Midterm S Rating",
  "Midterm F Rating",
  "Assessment E Rating",
  "Assessment S Rating",
  "Assessment F Rating",
];

type Row = [
  string | number | RowSpan,
  string | RowSpan,
  string | RowSpan,
  string | number | RowSpan,
  //
  string | number | RowSpan,
  string | number | RowSpan,
  string | number | RowSpan,
  //
  string | number | RowSpan,
  string | number | RowSpan,
  string | number | RowSpan,
  string | RowSpan,
  string | number | RowSpan,
  string | number | RowSpan,
  string | RowSpan,
  string | RowSpan,
  string | number | RowSpan, //   "E",
  string | number | RowSpan, //   "S",
  string | number | RowSpan, //   "F",
  string | number | RowSpan, //   "E",
  string | number | RowSpan, //   "S",
  string | number | RowSpan //   "F",
];

export interface IEmployeeTableRowItem {
  perspective: string; // "Perspective",
  strategicObjective: string; // "Strategic Objectives",
  contributoryObjective: string; // "Contributory Departmental Objective",
  weight: number; // "Weight (%)",

  draftComment: string; // "Draft Comment",
  midComment: string; // "Midterm Comment",
  assessComment: string; // "Assessment Comment",

  measure: string | number; // "Measures/KPI",
  baseline: string | number; // "Baseline",
  annualTarget: string | number; // "Annual Target",
  ratingScale: string; // "Annual Target",
  keyInitiatives: string | number; // "Key Initiatives",
  targetDate: string | number; // "Target Date",
  sourceOfEvidence: string; // "Source of Evidence",
  comments: string; // "Comments",
  dataType?: string; // "Data type"
  dataSymbol?: string; // "Symbol"
  autoRating: number | null;
  supervisorRating: number | null;
  finalRating: number | null;
  autoRating2: number | null;
  supervisorRating2: number | null;
  finalRating2: number | null;
}

const sortByPerspective = (
  a: IEmployeeTableRowItem,
  b: IEmployeeTableRowItem
) => {
  const perspectiveOrder = [
    "Financial Sustainability",
    "Stakeholder Value Addition",
    "Operational Excellence & Governance",
    "Human Capital & Transformation",
  ];
  // First sort by perspective
  let aIndex = perspectiveOrder.indexOf(a.perspective);
  let bIndex = perspectiveOrder.indexOf(b.perspective);

  if (aIndex === -1 || bIndex === -1) {
    return a.perspective.localeCompare(b.perspective);
  }

  if (aIndex !== bIndex) {
    return aIndex - bIndex;
  }

  // If perspectives are the same, sort by strategicObjective
  if (a.strategicObjective !== b.strategicObjective) {
    return a.strategicObjective.localeCompare(b.strategicObjective);
  }

  // If strategicObjectives are the same, sort by contributoryObjective
  return a.contributoryObjective.localeCompare(b.contributoryObjective);
};

const ConvertToTableRowItem = (
  strategicObjectives: IObjective[],
  contributoryObjectives: IObjective[],
  measures: IMeasure[]
) => {
  const tableRows: IEmployeeTableRowItem[] = measures.map((m) => {
    // get contributory objective
    const contributory = contributoryObjectives.find(
      (o) => o.id === m.objective
    );

    // get strategic objective
    const strategic = strategicObjectives.find((s) => {
      if (!contributory) return false;
      return s.id === contributory.parent;
    });

    const ratingScale = () => {
      const r1 = m.rating1
        ? `1 = ${dataFormat(m.dataType, m.rating1, m.dataSymbol)}`
        : "";
      const r2 = m.rating2
        ? `2 = ${dataFormat(m.dataType, m.rating2, m.dataSymbol)}`
        : "";
      const r3 = m.rating3
        ? `3 = ${dataFormat(m.dataType, m.rating3, m.dataSymbol)}`
        : "";
      const r4 = m.rating4
        ? `4 = ${dataFormat(m.dataType, m.rating4, m.dataSymbol)}`
        : "";
      const r5 = m.rating5
        ? `5 = ${dataFormat(m.dataType, m.rating5, m.dataSymbol)}`
        : "";
      const scale = `${r1}\n${r2}\n${r3}\n${r4}\n${r5}`;
      return scale;
    };

    const row: IEmployeeTableRowItem = {
      perspective: fullPerspectiveName(
        contributory ? contributory.perspective : ""
      ),
      strategicObjective: strategic
        ? strategic.description ?? "Error, not found!"
        : "Error, not found!",
      contributoryObjective: contributory
        ? contributory.description ?? "Error, not found!"
        : "Error, not found!",
      weight: contributory ? contributory.weight ?? 0 : 0,
      //
      draftComment: contributory ? contributory.draftComment ?? "-" : "",
      midComment: contributory ? contributory.midComment ?? "-" : "",
      assessComment: contributory ? contributory.assessComment ?? "-" : "",
      //
      measure: m ? m.description ?? "-" : "-",
      baseline: m
        ? dataFormat(m.dataType, m.baseline, m.dataSymbol) ?? "-"
        : "-",
      annualTarget: m
        ? dataFormat(m.dataType, m.annualTarget, m.dataSymbol) ?? "-"
        : "-",
      ratingScale: ratingScale(),
      keyInitiatives: m ? m.activities ?? "-" : "-",
      targetDate: m ? m.targetDate ?? "-" : "-",
      sourceOfEvidence: m ? m.sourceOfEvidence ?? "-" : "-",
      comments: m ? m.comments ?? "-" : "-",
      dataType: m.dataType,
      dataSymbol: m.dataSymbol,
      autoRating: m.autoRating,
      supervisorRating: m.supervisorRating,
      finalRating: m.finalRating,
      autoRating2: m.autoRating2,
      supervisorRating2: m.supervisorRating2,
      finalRating2: m.finalRating2,
    };

    return row;
  });

  return tableRows.sort(sortByPerspective);
};

const FormatTableSpan = (_rows: IEmployeeTableRowItem[]) => {
  const rows: Row[] = [];
  let currentPerspective = "";
  let currentStrategic = "";
  let currentContributory = "";
  let perspectiveStartIndex = -1;
  let strategicStartIndex = -1;
  let contributoryStartIndex = -1;

  // Group rows properly for spanning
  _rows.forEach((row, index) => {
    // Reset spans when perspective changes
    if (row.perspective !== currentPerspective) {
      currentPerspective = row.perspective;
      perspectiveStartIndex = index;
    }

    if (row.strategicObjective !== currentStrategic) {
      currentStrategic = row.strategicObjective;
      strategicStartIndex = index;
    }

    if (row.contributoryObjective !== currentContributory) {
      currentContributory = row.contributoryObjective;
      contributoryStartIndex = index;
    }

    // Calculate spans based on consecutive similar items
    const perspectiveSpan = _rows
      .slice(perspectiveStartIndex)
      .findIndex((r) => r.perspective !== currentPerspective);
    const strategicSpan = _rows
      .slice(strategicStartIndex)
      .findIndex((r) => r.strategicObjective !== currentStrategic);
    const contributorySpan = _rows
      .slice(contributoryStartIndex)
      .findIndex((r) => r.contributoryObjective !== currentContributory);

    const isFirstPerspectiveRow = index === perspectiveStartIndex;
    const isFirstStrategicRow = index === strategicStartIndex;
    const isFirstContributoryRow = index === contributoryStartIndex;

    const rowData: Row = [
      isFirstPerspectiveRow
        ? ({
          text: row.perspective,
          rowSpan:
            perspectiveSpan === -1
              ? _rows.length - perspectiveStartIndex
              : perspectiveSpan,
          fillColor: "#dedede",
        } as RowSpan)
        : ({} as RowSpan),

      isFirstStrategicRow
        ? ({
          text: row.strategicObjective,
          rowSpan:
            strategicSpan === -1
              ? _rows.length - strategicStartIndex
              : strategicSpan,
        } as RowSpan)
        : ({} as RowSpan),

      isFirstContributoryRow
        ? ({
          text: row.contributoryObjective,
          rowSpan:
            contributorySpan === -1
              ? _rows.length - contributoryStartIndex
              : contributorySpan,
        } as RowSpan)
        : ({} as RowSpan),

      isFirstContributoryRow
        ? ({
          text: row.weight.toString(),
          rowSpan:
            contributorySpan === -1
              ? _rows.length - contributoryStartIndex
              : contributorySpan,
        } as RowSpan)
        : ({} as RowSpan),

      // Comments with proper spanning
      isFirstContributoryRow
        ? ({
          text: row.draftComment,
          rowSpan: contributorySpan,
        } as RowSpan)
        : ({} as RowSpan),
      isFirstContributoryRow
        ? ({
          text: row.midComment,
          rowSpan: contributorySpan,
        } as RowSpan)
        : ({} as RowSpan),
      isFirstContributoryRow
        ? ({
          text: row.assessComment,
          rowSpan: contributorySpan,
        } as RowSpan)
        : ({} as RowSpan),

      // Remaining cells
      row.measure?.toString() || "-",
      row.baseline?.toString() || "-",
      row.annualTarget?.toString() || "-",
      row.ratingScale || "-",
      row.keyInitiatives?.toString() || "-",
      row.targetDate?.toString() || "-",
      row.sourceOfEvidence || "-",
      row.comments || "-",
      row.autoRating?.toString() || "0",
      row.supervisorRating?.toString() || "0",
      row.finalRating?.toString() || "0",
      row.autoRating2?.toString() || "0",
      row.supervisorRating2?.toString() || "0",
      row.finalRating2?.toString() || "0",
    ];

    rows.push(rowData);
  });

  return rows;
};


export const IndividualPerformanceAgreementDocument = async (
  title: string,
  strategicObjectives: IObjective[],
  contributoryObjectives: IObjective[],
  measures: IMeasure[]
) => {
  const logo = await brandLogo();
  const footer = await footerStripes();

  const rows: IEmployeeTableRowItem[] = ConvertToTableRowItem(
    strategicObjectives,
    contributoryObjectives,
    measures
  );

  // console.log("Row: ", rows);

  const mappedRows = FormatTableSpan(rows);

  const body = [tableHeader, ...mappedRows];

  const content = {
    pageSize: "A2", // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "landscape",
    footer,
    content: [
      logo,
      marginTopBottom(),
      header(title),
      marginTopBottom(),
      sectionHeader("Vision:"),
      sectionHeader("To be the leading electricity regulator in Africa"),
      marginTopBottom(),
      sectionHeader("Mission:"),
      sectionHeader(
        "To regulate the Namibian Electricity Supply Industry in a sustainable manner, in the interest of all stakeholders with regard to efficiency, affordability, safety and accessibility."
      ),
      marginTopBottom(),
        {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: body,
        },
      },
      companySignatureTable(),
      {
        logo,
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: body,
        },
      },
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
      },
    },
  };

  // console.log("PDF Content: \n", JSON.stringify(content));

  return content;
};
